import React from "react";
import styled from "styled-components";
import FormLabel from "./FormLabel";

const RadioContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
`;

const Label = styled.label`
  font-family: "Roboto", sans-serif;
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
`;

const Input = styled.input`
  position: absolute;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  opacity: 0;
  cursor: pointer;
`;

const CustomRadio = styled.span`
  width: 20px;
  height: 20px;
  border: 2px solid ${({ checked }) => (checked ? "#0098db" : "#acacac")};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;

  &::after {
    content: "";
    display: ${({ checked }) => (checked ? "block" : "none")};
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #0098db;
  }
`;

const Spacer = styled.div`
  width: 50px;
`;

const SizeRadioForm = ({ size, setSize }) => {
  const handleChange = (event) => {
    setSize(event.target.value);
  };

  return (
    <div>
      <FormLabel>Size</FormLabel>
      <RadioContainer>
        <Label htmlFor="size-s">
          <Input
            type="radio"
            id="size-s"
            name="size"
            value="S"
            checked={size === "S"}
            onChange={handleChange}
          />
          <CustomRadio checked={size === "S"} />S
        </Label>
        <Spacer />
        <Label htmlFor="size-m">
          <Input
            type="radio"
            id="size-m"
            name="size"
            value="M"
            checked={size === "M"}
            onChange={handleChange}
          />
          <CustomRadio checked={size === "M"} />M
        </Label>
        <Spacer />
        <Label htmlFor="size-l">
          <Input
            type="radio"
            id="size-l"
            name="size"
            value="L"
            checked={size === "L"}
            onChange={handleChange}
          />
          <CustomRadio checked={size === "L"} />L
        </Label>
        <Spacer />
        <Label htmlFor="size-xl">
          <Input
            type="radio"
            id="size-xl"
            name="size"
            value="XL"
            checked={size === "XL"}
            onChange={handleChange}
          />
          <CustomRadio checked={size === "XL"} />
          XL
        </Label>
      </RadioContainer>
    </div>
  );
};

export default SizeRadioForm;
